import React from 'react';
import { GraduationCap, ClipboardList, Presentation, Briefcase, Settings, Building, BookOpen, Rocket, HardHat } from '../../components/CustomIcons';
import ViewToggle, { ToggleSeparator } from '../../components/ViewToggle';

export const ROLES = [
  { key: 'learner', label: 'Learner', icon: GraduationCap },
  { key: 'case_manager', label: 'Case Manager', icon: ClipboardList },
  { key: 'instructor', label: 'Instructor', icon: Presentation },
  { key: 'facility_admin', label: 'Facility Admin', icon: Building },
  { key: 'employer', label: 'Employer/Partner', icon: Briefcase },
  { key: 'training_provider', label: 'Training Provider', icon: BookOpen },
  { key: 'youth_learner', label: 'Youth Learner', icon: Rocket },
  { key: 'professional_learner', label: 'Pro Learner', icon: HardHat },
  { key: 'admin', label: 'TTI Admin', icon: Settings },
];

const RoleSwitcher = ({ active, onChange, disabled }) => {
  return (
    <div
      className="mx-auto flex items-center gap-3 flex-wrap justify-center rounded-full px-5 py-3"
      style={{ background: '#0f2744', maxWidth: 'min(760px, 96vw)', opacity: disabled ? 0.5 : 1, pointerEvents: disabled ? 'none' : 'auto' }}
      data-testid="proto-role-switcher"
      aria-label="Demo role switcher"
    >
      <div className="flex items-center gap-2">
        <span
          className="text-[11px] font-semibold uppercase tracking-widest"
          style={{ color: '#f97316', fontFamily: 'var(--p-font-mono)' }}
        >
          {disabled ? 'Loading AssistivOS' : 'Demo Mode'}
        </span>
        <span className="w-px h-4" style={{ background: 'rgba(255,255,255,0.20)' }} aria-hidden="true" />
        <span className="text-[11px]" style={{ color: 'rgba(255,255,255,0.55)', fontFamily: 'var(--p-font-body)' }}>
          Switch role →
        </span>
      </div>
      <div className="flex items-center gap-1 flex-wrap">
        {ROLES.map((r) => {
          const isActive = r.key === active;
          const Icon = r.icon;
          return (
            <button
              key={r.key}
              onClick={() => !disabled && onChange(r.key)}
              data-testid={`proto-role-${r.key}`}
              aria-pressed={isActive}
              className="inline-flex items-center gap-1.5 rounded-[8px] px-3 py-1.5 text-[13px] font-semibold transition-all"
              style={{
                background: isActive ? '#f97316' : 'transparent',
                color: isActive ? '#0f2744' : '#ffffff',
                fontFamily: 'var(--p-font-body)',
              }}
              onMouseEnter={(e) => { if (!isActive) e.currentTarget.style.background = 'rgba(255,255,255,0.10)'; }}
              onMouseLeave={(e) => { if (!isActive) e.currentTarget.style.background = 'transparent'; }}
            >
              <Icon className="w-3.5 h-3.5" aria-hidden="true" />
              <span>{r.label}</span>
            </button>
          );
        })}
      </div>
      <div className="flex items-center gap-3">
        <ToggleSeparator tone="light" />
        <ViewToggle currentRole={active} source="prototype" />
      </div>
    </div>
  );
};

export default RoleSwitcher;
